















import {DATE_FORMAT, i18n} from '@/components/DatePicker';
import moment from 'moment';
import Pikaday from 'pikaday';
import {Component, Mixins} from 'vue-property-decorator';
import Control from './Control';

@Component
export default class DateControl extends Mixins<Control<string>>(Control) {

    private readonly MODEL_FORMAT = 'YYYY-MM-DD';
    private pikaday: Pikaday;

    protected filledValue: string = '';

    public created(): void {
        if (this.value === null) {
            return;
        }

        this.filledValue = moment(this.value, this.MODEL_FORMAT).format(DATE_FORMAT);
    }

    public mounted(): void {
        this.pikaday = new Pikaday({
            format: DATE_FORMAT,
            i18n,
            field: this.$refs.input as HTMLElement,
        });
    }

    public beforeUnmount(): void {
        this.pikaday.destroy();
    }

    protected change(event: any) {
        this.filledValue = event.target.value;
        this.updateValue();
    }

    protected validateCurrentValue(): boolean {
        return this.filledValue === '' || this.getValue() !== null;
    }

    protected getValue(): string | null {
        if (this.filledValue === '') {
            return null;
        }

        const date = moment(this.filledValue, DATE_FORMAT);

        return date.isValid()
            ? date.format(this.MODEL_FORMAT)
            : null;
    }
}
